import { v4 as uuidv4 } from 'uuid'

import { targetingTypes } from '../../../LineItemDv360Create/fields'
import {
  safetyOptions,
  UNSPECIFIED,
  UREATED_URLS_SEGMENT_ID
} from '../../../../UploadDV360AdCreative/UploadDV360AdCreativeForm/LineItemForm/fields'

const getIntegralAdScience = targeting => {
  return (
    targeting.find(option => option.type === targetingTypes.TARGETING_TYPE_THIRD_PARTY_VERIFIER)?.integral_ad_science ||
    {}
  )
}

export const getFormattedSafetyOptions = targeting => {
  const integralAdScience = getIntegralAdScience(targeting)

  return safetyOptions.reduce((acc, option) => {
    const safetyOptionValue = integralAdScience[option.fieldName]
    if (safetyOptionValue) {
      // format string like "SUSPICIOUS_ACTIVITY_HR" to "HR"
      acc[option.value] = safetyOptionValue.split(option.value + '_')[1]
    } else {
      acc[option.value] = UNSPECIFIED
    }

    return acc
  }, {})
}

export const getExcludeUnrateable = targeting => {
  const integralAdScience = getIntegralAdScience(targeting)
  return !!integralAdScience.excludeUnrateable
}

export const getFormattedCustomSegmentIds = targeting => {
  const integralAdScience = getIntegralAdScience(targeting)
  const customSegmentIds = integralAdScience.customSegmentId || []

  return (
    customSegmentIds
      .map(customSegmentId => ({
        text: customSegmentId,
        id: uuidv4()
      }))
      // We don't need to show the UREATED_URLS_SEGMENT_ID in the list, so we filter it out,
      // and then preselect BLOCK_UNRATED_URLS checkbox if it's present in the initial list
      .filter(customSegmentId => customSegmentId.text !== UREATED_URLS_SEGMENT_ID)
  )
}

export const getBlockUnratedUrls = targeting => {
  const integralAdScience = getIntegralAdScience(targeting)
  const customSegmentIds = integralAdScience.customSegmentId || []
  return customSegmentIds.some(customSegmentId => customSegmentId === UREATED_URLS_SEGMENT_ID)
}
